import {post, deletep} from "../util/Api"
import {setFilterUser, setUser} from "../action/login";
import {setCookie, deleteCookie} from "../util/cookie";
import {getAllDevicesByMap} from "./device";
import {setCurrentItemChangeActive, updateAllDevicesSubInfo} from "../action/page";

export const login = (params) => (dispatch) => {
    return new Promise((resolve, reject) => {
        post("login", params, {withCredentials: true}).then(data => {
            const {status} = data || "";
            if (status === "ok") {
                localStorage.setItem("refreshToken", data.data.token.refreshToken);
                setCookie("token", data.data.token.token, 1);
                dispatch(setUser(data.data));
                if(data.data.user.companyId) {
                    dispatch(updateAllDevicesSubInfo({companyId: data.data.user.companyId}));
                }
                resolve(status)
            } else {
                reject(data);
            }
        })
    });
}

export const checkToken = params => dispatch => {
    return new Promise((resolve, reject) => {
        post("checkToken", params).then(data => {
            const {status} = data || "";
            if (status === "ok") {
                dispatch(setUser(data.data));
                resolve();
            } else {
                reject();

            }
        }).catch(err => {
            reject(err);
        })
    })
}

export const logout_user = data => dispatch => {
    return new Promise((resolve, reject) => {
        deletep("logout", {}).then(data => {
            const {status} = data || "";
            if (status === "ok") {
                deleteCookie('token');
                localStorage.removeItem("refreshToken");
                dispatch(setUser({}));
                dispatch(getAllDevicesByMap());
                dispatch(setCurrentItemChangeActive(false));
                dispatch(setFilterUser({findByCompanyId: false}));
                dispatch(updateAllDevicesSubInfo(""));
                window.location.href = "/";
                resolve();
            } else {
                reject();
            }
        }).catch(err => {
            reject(err);
        })
    })
}
